import React from 'react';
import Layout from '../layout';
import Download from '../views/features/Download';

const DownloadPage = ({
  pageContext: { data = {}, metaData = {}, menus = [] },
  location,
}) => {
  return (
    <Layout SEOTitle={data.label} metaData={metaData} menus={menus}>
      <Download
        location={location}
        sections={data.sections}
        metaData={metaData}
      />
    </Layout>
  );
};

export default DownloadPage;
